export const collaboratorQueryKeys = {
  all: ["collaborator"] as const,
  lists: (asAcExpo?: boolean) => [
    ...collaboratorQueryKeys.all,
    "lists",
    asAcExpo,
  ],
};
